export default Object.freeze({
  EFH: {text: 'Ein-/Zweifamilienhaus', value: 'EFH'},
  ZFH: {text: 'Zweifamilienhaus', value: 'ZFH'},
  ETW: {text: 'Eigentumswohnung', value: 'ETW'},
  MFH: {text: 'Mehrfamilienhaus bis 1.000m', value: 'MFH'},
  WGH: {text: 'Wohn- und Geschäftshaus', value: 'WGH'},

  values: function () {
    return [this.EFH.value, this.ZFH.value, this.ETW.value, this.MFH.value, this.WGH.value];
  },

  objects: function () {
    return [this.EFH, this.ZFH, this.ETW, this.MFH, this.WGH];
  },
});